import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { removeAllocationError } from "@planzone/dto";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (allocation) => {
    return present(
      repository
        .removeAllocation(allocation)
        .then(() => allocation)
        .catch((e) =>
          Promise.reject({
            error: { ...removeAllocationError, ...e },
            allocation,
          }),
        ),
    );
  };
}

export type { Interactor };

export { createInteractor };
